import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { prettyFloat } from 'webui/utils/number';
import { OpenThermStatusFlag } from 'openTherm';
export function value_row(title, value, unit) {
    if (unit != null) {
        return (_jsxs("tr", { children: [_jsx("th", { children: title }), _jsx("td", { className: "value", children: value }), _jsx("td", { className: "unit", children: unit })] }));
    }
    return (_jsxs("tr", { children: [_jsx("th", { children: title }), _jsx("td", { className: "value", colSpan: 2, children: value })] }));
}
// FIXME: delete if not use in for legacy devices
export function OTStateTable({ ot }) {
    return (_jsx("table", { children: _jsxs("tbody", { children: [ot.cs != null &&
                    value_row('Заданная t° теплоносителя', prettyFloat(ot.cs, 1), '°C'), ot.bt != null &&
                    value_row('Фактическая t° теплоносителя', prettyFloat(ot.bt, 1), '°C'), ot.dt != null &&
                    value_row('Фактическая t° ГВС', prettyFloat(ot.dt, 1), '°C'), ot.rwt != null &&
                    value_row('t° обратного потока', prettyFloat(ot.rwt, 1), '°C'), ot.ot != null &&
                    value_row('Температура вне дома', prettyFloat(ot.ot, 1), '°C'), ot.wp != null &&
                    value_row('Давление теплоносителя', prettyFloat(ot.wp, 1), 'бар'), ot.rml != null &&
                    value_row('Уровень модуляции', prettyFloat(ot.rml, 1), '%'), ot.fr != null &&
                    value_row('Скорость потока ГВС', prettyFloat(ot.fr, 1), 'л/мин'), ot.s != null &&
                    value_row('Горелка', ot.s.includes(OpenThermStatusFlag.fl)
                        ? 'активна'
                        : 'не активна', '')] }) }));
}
